import loadable from '@loadable/component'

export const Research = loadable(() => import('./Research'))
export const ResearchItem = loadable(() => import('./ResearchItem'))
export const ResearchHighlight = loadable(() => import('./ResearchHighlight'))
export type { ResearchProps } from './Research'
export type {
  ResearchItemRenderLinkProps,
  ResearchItemProps
} from './ResearchItem'
export type {
  ResearchHighlightRenderLinkProps,
  ResearchHighlightProps,
  ResearchHighlightImage
} from './ResearchHighlight'
export { default as researchMocks } from './__mocks__/Research.mock'
